import React from 'react';
import SaveButton from '../../../../components/SaveButton/SaveButton';
import {checkIfPersonalInfoIsValid} from '../../../../validation/FormValidation';
import {updatePersonalInfoEditMode} from '../../../../redux/app-state-slice';
import InfoCircleIcon from '../../../../assets/icons/info-circle-light-blue.svg';
import PersonalInfoSection from '../../PrequalForm/PersonalInfoSection/PersonalInfoSection';
import {ToolTip} from '../../../../components/ToolTip/ToolTip';

function PersonalInfoReview({customerData, dispatch, appConfig}) {
  function getDealerHostReviewPageContainerClass() {
    return customerData.isDealerHostApplication.value ? 'prequal--wc--review-page-item-container' : '';
  }

  return (
    <>
      {!customerData.cardEditFlags.personalInfoEditMode.value && (
        <>
          <div className={`prequal--web--review-page-padding-20 ${getDealerHostReviewPageContainerClass()}`}>
            <label className='prequal--web--label-fomo'>Full Name</label>
            <p className='prequal--web--display-text-fomo'>
              <span>
                {customerData.firstName.value} {customerData.lastName.value}
              </span>
            </p>
          </div>
          <div className='prequal--web--review-page-padding-28-fomo'>
            <label className='prequal--web--label-fomo'>Email&nbsp;</label>
            {!customerData.isDealerHostApplication.value && (
              <span className='prequal--web--review--popover-container'>
                <ToolTip
                  content=' Your email is required to send you a copy of your prequalification offer.'
                  position='right-start'
                  header='Email Required'
                  tooltipIcon={InfoCircleIcon}
                />
              </span>
            )}
            <p className='prequal--web--display-text-fomo'>
              <span>{customerData.email.value}</span>
            </p>
          </div>
          <div className='prequal--web--review-page-padding-28-fomo'>
            <label className='prequal--web--label-fomo'>Date of Birth</label>
            <p className='prequal--web--display-text-fomo'>
              <span>
                {customerData.dateOfBirth.month.value}/{customerData.dateOfBirth.day.value}/{customerData.dateOfBirth.year.value}
              </span>
            </p>
          </div>
        </>
      )}
      {customerData.cardEditFlags.personalInfoEditMode.value && (
        <>
          <div className={`prequal--web--review-page-padding-20 ${getDealerHostReviewPageContainerClass()}`} />
          <PersonalInfoSection customerData={customerData} dispatch={dispatch} appConfig={appConfig} />
          <SaveButton
            onClickHandler={() => (checkIfPersonalInfoIsValid(customerData) ? dispatch(updatePersonalInfoEditMode(false)) : null)}
            isFieldValid={checkIfPersonalInfoIsValid(customerData)}
          />
        </>
      )}
    </>
  );
}

export default PersonalInfoReview;
